/**
 * Normaliza un error de axios a un string seguro para pasar a toast.error().
 *
 * FastAPI puede devolver `detail` como string (HTTPException) o como un array de
 * objetos {loc, msg, type} (errores de validación 422). Pasarle ese array/objeto
 * directo a toast.error() rompe el render de React ("Objects are not valid as a
 * React child"). Esta función siempre devuelve un string.
 *
 * @param {unknown} error - el error capturado (típicamente de axios)
 * @param {string} fallback - mensaje a usar si no se puede extraer uno legible
 * @returns {string}
 */
export function getErrorMessage(error, fallback = 'Error al procesar la solicitud') {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  // Forma 422 de FastAPI: lista de errores de validación.
  if (Array.isArray(detail)) {
    const msg = detail.find((item) => typeof item?.msg === 'string')?.msg;
    return msg || fallback;
  }

  return fallback;
}

export default getErrorMessage;
